import {Global,EnvType,Constants} from "./global";
import {message} from "antd";

const getQueryString = (name) => {
    var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
    var r = window.location.search.substr(1).match(reg);
    if (r != null) return unescape(r[2]);
    return null;
}
const getRequestDomain = (type) => {

    const REACT_APP_PROXY_URL = process.env.REACT_APP_PROXY_URL
    if (REACT_APP_PROXY_URL === EnvType.PRO) {//生产环境
       return Global.PRO_API_DOMAIN;
    } else if (REACT_APP_PROXY_URL === EnvType.DEV) {//开发环境np
        return Global.DEV_API_DOMAIN;
    } else {//本地跑的服务
        return Global.LOCAL_API_DOMAIN;
    }
}
const messageTips = (content,type,time) => {
    if(type==="success"){
        message.destroy();
        message.success({
            content:content,className:"message-tips",duration:time?time:3,key:"tips-success"
        })
    }else if(type ==="error"){
        message.destroy();
        message.error({
            content:content,className:"message-tips",duration:time?time:3,key:"tips-error"
        })

    }else{
        message.destroy();
        message.error({
            content:content,className:"message-tips",duration:time?time:3,key:"tips-error"
        })
    }
}
const getDingdingRequestDomain = () => {

    const REACT_APP_PROXY_URL = process.env.REACT_APP_PROXY_URL
    if (REACT_APP_PROXY_URL === EnvType.PRO) {//生产环境
       return Global.DINGDING_SCAN_URL;
    } else if (REACT_APP_PROXY_URL === EnvType.DEV) {//开发环境np
        return Global.DEV_API_DOMAIN;
    } else {//本地跑的服务
        return Global.DEV_API_DOMAIN;
    }
}

const getDingDingAppId = () => {
    const REACT_APP_PROXY_URL = process.env.REACT_APP_PROXY_URL
    if (REACT_APP_PROXY_URL === EnvType.PRO) {//生产环境
        return "dingoa6av4ybbemifbhfkd";
    } else if (REACT_APP_PROXY_URL === EnvType.DEV) {//开发环境np
        return "dingoa9hz9pcssc7vcw31g";
    } else {//本地跑的服务
        return "dingoa9hz9pcssc7vcw31g";
    }
}

const getDDCodeLoginRequestDomain = (type) => {
    const REACT_APP_PROXY_URL = process.env.REACT_APP_PROXY_URL
    if (REACT_APP_PROXY_URL === EnvType.PRO) {//生产环境
        return Global.PRO_DDCODE_LOGIN_API_DOMAIN;
    } else if (REACT_APP_PROXY_URL === EnvType.DEV) {//开发环境np
        return Global.DEV_DDCODE_LOGIN_API_DOMAIN;
    } else {//本地跑的服务
        return Global.DEV_DDCODE_LOGIN_API_DOMAIN;
    }
}

const getFeishuAppId = () => {
    const REACT_APP_PROXY_URL = process.env.REACT_APP_PROXY_URL
    if (REACT_APP_PROXY_URL === EnvType.PRO) {//生产环境
        return Constants.PRO_FEISHU_APP_ID;
    } else if (REACT_APP_PROXY_URL === EnvType.DEV) {//开发环境np
        return Constants.DEV_FEISHU_APP_ID;
    } else {//本地跑的服务
        return Constants.DEV_FEISHU_APP_ID;
    }
}

export {
    getQueryString,
    getRequestDomain,
    getDingdingRequestDomain,
    getDingDingAppId,
    messageTips,
    getDDCodeLoginRequestDomain,
    getFeishuAppId
}
    